<template>
    <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
        style="overflow: hidden;">
        <div class="m-portlet m-portlet--mobile">
            <PageHead label='住培生信息' label2="修改住培生" url="/person/stu/list"></PageHead>
            <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
                ref="form">
                <div class="m-portlet__body">
                    <!--begin: Form Body -->
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">姓名：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuname" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
                                <el-input v-model="form.stuname" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">工号：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuno" :rules="{required: true, message: '工号不能为空', trigger: 'blur'}">
                                <el-input v-model="form.stuno" placeholder="请输入工号"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">科室：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stusec" :rules="{required: true, message: '科室不能为空', trigger: 'blur'}">
                                <ZPGLFormDictItemSelect v-bind:val_1="form.stusec" v-model="form.stusec"
                                    :dictid='this.$utils.DictEnum.section'></ZPGLFormDictItemSelect>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">专业：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuspec" :rules="{required: true, message: '专业不能为空', trigger: 'blur'}">
                                <ZPGLFormDictItemSelect v-bind:val_1="form.stuspec" v-model="form.stuspec"
                                    :dictid='this.$utils.DictEnum.specialty'></ZPGLFormDictItemSelect>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">类型：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuusertype"
                                :rules="{required: true, message: '类型不能为空', trigger: 'blur'}">
                                <ZPGLFormDictItemSelect v-bind:val_1="form.stuusertype" v-model="form.stuusertype"
                                    :dictid='this.$utils.DictEnum.usertype'></ZPGLFormDictItemSelect>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">培养年限：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stueduyear"
                                :rules="{required: true, message: '培养年限不能为空', trigger: 'blur'}">
                                <el-select v-model="form.stueduyear" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in trainingyearOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">届别：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuyear" :rules="{required: true, message: '届别不能为空', trigger: 'blur'}">
                                <ZPGLFormDictItemSelect v-bind:val_1="form.stuyear" v-model="form.stuyear"
                                    :dictid='this.$utils.DictEnum.stuyear'></ZPGLFormDictItemSelect>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">培训状态：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stueditstatus"
                                :rules="{required: true, message: '培训状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.stueditstatus" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in trainingstatusOptions" :key="item.value"
                                        :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">是否本院人员：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuismeals"
                                :rules="{required: true, message: '是否本院人员状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.stuismeals" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in mealOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">住宿：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuislive"
                                :rules="{required: true, message: '住宿状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.stuislive" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in accommodationOptions" :key="item.value"
                                        :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" style="display: none;">
                        <label class="col-xl-2 col-form-label">执医：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuismeals"
                                :rules="{required: true, message: '执医状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.isdoctor" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label" style="display: none;">交通：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="stuismeals"
                                :rules="{required: true, message: '交通状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.istraffic" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in trafficOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">单位：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="companyinfo">
                                <el-input v-model="form.companyinfo" placeholder="请输入单位"></el-input>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">手机号：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="phone">
                                <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">银行：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="bank">
                                <el-input v-model="form.bank" placeholder="请输入银行"></el-input>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">卡号：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="bankno">
                                <el-input v-model="form.bankno" placeholder="请输入卡号"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <label class="col-xl-2 col-form-label">是否执医：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="iszy" :rules="{required: true, message: '是否执医不能为空', trigger: 'blur'}">
                                <el-select v-model="form.iszy" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in trueOrfalseOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <label class="col-xl-2 col-form-label">是否完成加注：</label>
                        <div class="col-xl-3">
                            <el-form-item prop="isjz" :rules="{required: true, message: '完成加注状态不能为空', trigger: 'blur'}">
                                <el-select v-model="form.isjz" filterable placeholder="请选择">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option v-for="item in trueOrfalseOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                        <div class="m-form__actions m-form__actions--solid">
                            <div class="row">
                                <div class="col-lg-12 m--align-center">
                                    <SaveButton :url='saveUrl' back="/person/stu/list"></SaveButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StuEdit',
        data () {
            return {
                form: {
                    stuname: '',
                    stuno: '',
                    stusec: '',
                    stuspec: '',
                    stuyear: '',
                    stueduyear: '',
                    stueditstatus: '',
                    stuismeals: '',
                    stuislive: '',
                    stuusertype: '',
                    isdoctor: '',
                    istraffic: '',
                    companyinfo: '',
                    bank: '',
                    bankno: '',
                    phone: '',
                    iszy: '否',
                    isjz: '否',
                },
                trainingyearOptions: [{
                    value: '1',
                    label: '一年生'
                }, {
                    value: '2',
                    label: '两年生'
                }, {
                    value: '3',
                    label: '三年生'
                }, {
                    value: '4',
                    label: '往届生'
                }],
                trainingstatusOptions: [{
                    value: '1',
                    label: '未入科'
                }, {
                    value: '2',
                    label: '在培'
                }, {
                    value: '3',
                    label: '缺勤'
                }, {
                    value: '4',
                    label: '延期'
                }, {
                    value: '5',
                    label: '已结业'
                }],
                mealOptions: [{
                    value: '1',
                    label: '是'
                }, {
                    value: '2',
                    label: '否'
                }],
                accommodationOptions: [{
                    value: '1',
                    label: '有'
                }, {
                    value: '2',
                    label: '无'
                }],
                doctorOptions: [{
                    value: '1',
                    label: '有'
                }, {
                    value: '2',
                    label: '无'
                }],
                trafficOptions: [{
                    value: '1',
                    label: '有'
                }, {
                    value: '2',
                    label: '无'
                }],
                trueOrfalseOptions: [{
                    value: '是',
                    label: '是'
                }, {
                    value: '否',
                    label: '否'
                }],
                saveUrl: this.$utils.Url.zpgl + '/api/APIStu/Update',
                fullscreenLoading: false
            }
        },
        mounted: function () {
            this.form.token = sessionStorage.getItem('token')
            this.form.id = this.$route.params.id
            // 获取数据字典信息
            var args = {
                id: this.form.id,
                token: this.form.token
            }
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStu/Info', args, function (data, model) {
                model.stuname = data.Data.StuName
                model.stuno = data.Data.StuNo
                if (data.Data.StuSec != null) {
                    model.stusec = data.Data.StuSec
                }
                if (data.Data.StuSpec != null) {
                    model.stuspec = data.Data.StuSpec
                }
                if (data.Data.StuYear != null) {
                    model.stuyear = data.Data.StuYear
                }
                if (data.Data.StuEduYear != null) {
                    model.stueduyear = String(data.Data.StuEduYear)
                }
                if (data.Data.StuEditStatus != null) {
                    model.stueditstatus = String(data.Data.StuEditStatus)
                }
                if (data.Data.StuIsMeals != null) {
                    model.stuismeals = String(data.Data.StuIsMeals)
                }
                if (data.Data.StuIsLive != null) {
                    model.stuislive = String(data.Data.StuIsLive)
                } else {
                    model.stuislive = 2
                }
                if (data.Data.StuUserType != null) {
                    model.stuusertype = data.Data.StuUserType
                }
                if (data.Data.IsDoctor != null) {
                    model.isdoctor = String(data.Data.IsDoctor)
                }
                if (data.Data.IsTraffic != null) {
                    model.istraffic = String(data.Data.IsTraffic)
                }
                model.companyinfo = data.Data.CompanyInfo
                model.bank = data.Data.Bank
                model.bankno = data.Data.BankNo
                model.phone = data.Data.Phone
                model.iszy = data.Data.iszy
                model.isjz = data.Data.isjz
            }, null, null, this.form)
        }
    }
</script>

<style scoped="scoped">
    .el-form-item {
        margin-bottom: 0px;
    }

    .el-select {
        width: 100%;
    }
</style>